module.exports = __webpack_public_path__ + "img/lightLogo.2145d798.png";